module.exports = __webpack_public_path__ + "img/ic_dashboard_pause.48bafc52.svg";